'use strict';

import {getPrefixedDataSet} from "@elements/data-set-utils";
import initModulesInScope from "@elements/init-modules-in-scope";

const defaultSelectors = {
    base: '.js-consent',
    template: '.js-consent__template',
    dataset: 'consent',
    button: '.js-consent__accept-btn'
};

const defaultOptions = {
    revalidateEvent: 'cookieyes_consent_update'
};

export function initInScope($scope) {
    $scope.find(defaultSelectors.base).each(function () {
        createConsentOverlay(this, defaultOptions, defaultSelectors);
    });
}

function createConsentOverlay(baseElement, options, selectors) {
    let data = getPrefixedDataSet(selectors.dataset, $(baseElement));
    let button = $(baseElement).find(selectors.button);

    document.addEventListener('cookieyes_banner_load', function () {
        const consentData = window.getCkyConsent();
        if (consentData.categories[data.service]) {
            renderTemplate(baseElement, { base: selectors.base, template: selectors.template });
        } else {
            if ($(baseElement).attr('hidden')) {
                $(baseElement).removeAttr('hidden');
            }
        }
    });

    document.addEventListener('cookieyes_consent_update', function () {
        const consentData = window.getCkyConsent();
        console.log(consentData);

        if (consentData.categories[data.service]) {
            renderTemplate(baseElement, { base: selectors.base, template: selectors.template });
        } else {
            if ($(baseElement).attr('hidden')) {
                $(baseElement).removeAttr('hidden');
            }
        }

        $(window).on(options.revalidateEvent, function () {
            const updatedConsentData = window.getCkyConsent();
            if (updatedConsentData.categories[data.service]) {
                renderTemplate(baseElement, { base: selectors.base, template: selectors.template });
            } else {
                if ($(baseElement).attr('hidden')) {
                    $(baseElement).removeAttr('hidden');
                }
            }
        });

        if (button.length > 0) {
            button.on('click', function () {
                const consentCategory = data.service;
                console.log('clickcategory:', consentCategory);

                // Mapping between consent categories and corresponding element IDs
                const consentMapping = {
                    analytics: "#ckySwitchanalytics",
                    advertisement: "#ckySwitchadvertisement",
                    functional: "#ckySwitchfunctional",
                    performance: "#ckySwitchperformance",
                    other: "#ckySwitchother"
                };

                $.each(consentMapping, function(category, elementId) {
                    // console.log('category:', category, 'consentCategory:', consentCategory);
                    // console.log($(elementId).prop("checked", category === consentCategory));
                    $(elementId).prop("checked", category === consentCategory);

                });

                performBannerAction("accept_partial");
            });
        }
    });
}

export function renderTemplate(renderItem, selectors) {
    let template = $(renderItem).find(selectors.template);

    if (template) {
        let parent = $(renderItem).parent();
        if (parent.length > 0) {
            $(parent).html($(template).html());
            initModulesInScope(parent)
            // if (renderItem) {
            //     initModulesInScope($(renderItem).parent());
            // } else {
            //     initModulesInScope(parent)
            // }
        }
    }
}